export interface OutputLanguagesType {
    framework_id: string | null;
    id: number;
    name: string;
    document_id?: string;
    language_code: string;
    shown?: boolean;
    country_code: string;
    language_name: string;
    country: string;
}
export interface JobLanguagesType {
    languages: string[];
    target_country_code: string;
    target_country: string;
    brand: string;
}
export interface LanguagesType {
    key: string;
    title: string;
    document_id?: string;
}

export interface BrandType {
    key: string;
    name: string;
    document_id?: string;
    countries?: string[];
}

export const CLIENT = 'client';
export const BRAND = 'brand';
